import { render, staticRenderFns } from "./hydrology-wen-xj.vue?vue&type=template&id=b9f6bcfa&"
import script from "./hydrology-wen-xj.vue?vue&type=script&lang=js&"
export * from "./hydrology-wen-xj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports